import { BackgroundProcessSilent } from '../../common/resources';

const jobCountElements = window.jQuery('.queue-status_total-jobcount');
const queueListElements = window.jQuery('.queue-status_list');
let intervalId = null;

async function refreshQueueStatus() {
    try {
        const status = await BackgroundProcessSilent.segment('status').get();

        if (status.queueStatuses) {
            const total = status.queueStatuses.reduce((sum, { jobCount }) => sum + jobCount, 0);

            jobCountElements.text(
                total
            );
            queueListElements.html('');

            if (status.queueStatuses.length === 0) {
                queueListElements.append('<li>Geen actieve background jobs</>');
            } else {
                status.queueStatuses.forEach(({ name, jobCount }) => {
                    queueListElements.append(`<li>${name}: ${jobCount}</li>`);
                });
            }
        }
    } catch (e) {
        console.log(e);
        if (intervalId) {
            clearInterval(intervalId);
        }

        jobCountElements.text(
            'Geen status beschikbaar'
        );
        queueListElements.html('');
    }
}

refreshQueueStatus();
intervalId = setInterval(refreshQueueStatus, 10000);
